import { ActionIcon, Button, Stack, TextInput } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";

export const MetadataEditor = ({
  value = [],
  onChange,
}: {
  value?: Array<{ property: string; value: string }>;
  onChange: (metadata: Array<{ property: string; value: string }>) => void;
}) => {
  const [metadata, setMetadata] = useState(
    value.map((item) => ({
      property: item.property || "",
      value: item.value || "",
    })),
  );

  useEffect(() => {
    onChange(metadata);
  }, [metadata]);

  return (
    <Stack>
      <Button
        size="xs"
        onClick={() => {
          setMetadata([...metadata, { property: "", value: "" }]);
        }}
      >
        Add Metadata Field
      </Button>
      {metadata.length > 0 && (
        <DataTable
          records={metadata}
          columns={[
            {
              accessor: "property",
              title: "Property",
              render: (record, index) => (
                <TextInput
                  placeholder="property_name"
                  value={record.property}
                  onChange={(e) => {
                    const newMetadata = [...metadata];
                    newMetadata[index].property = e.target.value;
                    setMetadata(newMetadata);
                  }}
                />
              ),
            },
            {
              accessor: "value",
              title: "Value",
              render: (record, index) => (
                <TextInput
                  placeholder="value"
                  value={record.value}
                  onChange={(e) => {
                    const newMetadata = [...metadata];
                    newMetadata[index].value = e.target.value;
                    setMetadata(newMetadata);
                  }}
                />
              ),
            },
            {
              accessor: "actions",
              title: "",
              render: (record, index) => (
                <ActionIcon
                  color="red"
                  onClick={() => {
                    const newMetadata = [...metadata];
                    newMetadata.splice(index, 1);
                    setMetadata(newMetadata);
                  }}
                >
                  <IconTrash size={16} />
                </ActionIcon>
              ),
            },
          ]}
        />
      )}
    </Stack>
  );
};
